import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom, map } from 'rxjs';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';


export interface UsuarioBusqueda {
  apellidoMaterno: string;
  apellidoPaterno: string;
  correo: string;
  nombres: string;
  rut: number;
  rutDv: string;
  insRut: number;
  insRutDv: string | null;
}

interface UsuarioBusquedaResponse { 
  usu_apellido_materno: string;
  usu_apellido_paterno: string;
  usu_mail: string;
  usu_nombres: string;
  usu_rut: number;
  usu_rutdv: string;
  ins_rut: number;
  ins_rutdv: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class UsuarioBusquedaService {

  constructor(private http: HttpClient, private authService: BackendAuthService, private sessionService: SessionService) { }

  async buscarPorRut(rut: string): Promise<UsuarioBusqueda> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const url = `${environment.backendUrl}/esi-usuario-por-rut?rut=${rut}`;
    const request$ = this.http.post<{ success: string, data: any }>(url, {}, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'session_id': this.sessionService.getToken() || ''
      }
    });
    const usuario = await firstValueFrom(request$.pipe(map((response) => response.data as UsuarioBusquedaResponse)));
    return {
      apellidoMaterno: usuario.usu_apellido_materno,
      apellidoPaterno: usuario.usu_apellido_paterno,
      correo: usuario.usu_mail,
      nombres: usuario.usu_nombres,
      rut: usuario.usu_rut,
      rutDv: usuario.usu_rutdv,
      insRut: usuario.ins_rut,
      insRutDv: usuario.ins_rutdv,
    }
  }
}
